export const GET_ALL_USER: string = "GET_ALL_USER";
export const GET_SPECIFIC_VIEW_USER: string = "GET_SPECIFIC_VIEW_USER";
export const GET_ALL_USER_BY_DATE: string = "GET_ALL_USER";
export const GET_USER_LOG_DATE: string = "GET_USER_LOG_DATE";
export const GET_ONE_USER: string = "GET_ONE_USER";
export const LOADING: string = "LOADING";

